import { createHttpLink } from 'apollo-link-http';

export default (ctx) => {
    const headers = {
        'x-api-key': ctx.$config.graphqlApiKey, // this is performed too early, so we do not have ctx.$auth
        'x-web-build-version': ctx.$config.webBuildVersion,
    };

    if (process.server) {
        headers['user-agent'] = 'beams-ssr/' + ctx.$config.webBuildVersion + ' ' + ctx.req.headers['user-agent'];
    }
    let link;
    let httpEndpoint;
    let defaultHttpLink = true;

    if (process.client) {
        defaultHttpLink = false;
        link = createHttpLink({
            uri: ctx.$config.graphqlApiURL,
            headers,
            fetch: async (uri, options) => {
                if (ctx.$auth.strategy.token.status().expired()) {
                    try {
                        await ctx.$auth.refreshTokens();
                        options.headers['Authorization'] = ctx.$auth.strategy.token.get().split(' ')[1];
                    } catch (e) {
                        ctx.store.dispatch('authStore/logout');
                    }
                }
                return fetch(uri, options);
            },
        });
    } else {
        httpEndpoint = ctx.$config.graphqlApiURL;
    }

    return {
        defaultHttpLink,
        link,
        httpEndpoint,
        httpLinkOptions: {
            headers,
        },
        getAuth: () => {
            let token = ctx?.$auth?.strategy?.token?.get();
            return token ? token.split(' ')[1] : null;
        },
    };
};
